import { IJsonObject } from "../api";

interface IProps {
	id?: number | null;
	name?: string;
	type?: string | null;
	order_column?: number | null;
}

export class Tag {
	public static fromJson(json: IJsonObject): Tag {
		return new Tag({
			id: json.id as number,
			name: json.name as string,
			type: (json.type as string | null) ?? null,
			order_column: (json.order_column as number | null) ?? null,
		});
	}

	public static fromJsonArray(json: IJsonObject[]): Tag[] {
		return json.map((item: IJsonObject) => Tag.fromJson(item));
	}

	public id: number | null;
	public name: string;
	public type: string | null;
	public order_column: number | null;

	constructor({
		id = null,
		name = "",
		type = null,
		order_column = null,
	}: IProps = {}) {
		this.id = id ?? null;
		this.name = name;
		this.type = type;
		this.order_column = order_column;
	}
}
